import type { SVGProps } from 'react'

export const BarcodeReaderFillIcon = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M230.43-106.61q-62.87 0-100.28-49.01-37.41-49.01-21.69-108.88l72.47-274.39q-33.47-21.96-54.73-58.79-21.27-36.84-21.27-82.32 0-68.15 48.44-116.59 48.43-48.43 116.59-48.43h317.37q51.21 0 77.56 43.14t3.48 88.64L594.35-565.2q-12.2 22.87-33.57 36.55-21.37 13.67-47.48 13.67h-76.93l-11 40.48h9.13q18.91.48 31.61 13.53Q478.8-447.91 478.8-429v77.61q0 19.15-13.17 32.33-13.17 13.17-32.33 13.17h-52.32l-28.33 105.54q-11.48 41.39-45.15 67.57-33.67 26.17-77.07 26.17Zm653.03-707.35-90 41q-11.96 5.48-24.3.62-12.33-4.86-17.81-16.81-5.48-11.96-1.12-24.3 4.36-12.33 16.31-17.81l90-41q11.96-5.48 24.8-.62 12.83 4.86 18.31 16.81 5.48 11.96.62 24.3t-16.81 17.81ZM767.54-527.74q-11.95-5.48-17.31-18.19-5.36-12.72.12-24.68 5.48-12.96 18.31-17.43 12.84-4.48 25.8 1l90 42q11.71 5.47 16.19 17.81t-1 24.3q-5.48 11.95-17.81 16.81-12.34 4.86-24.3-.62l-90-41Zm129.63-119.87h-100q-13.95 0-23.17-9.22-9.22-9.21-9.22-23.17t9.22-23.17q9.22-9.22 23.17-9.22h100q13.96 0 23.18 9.22 9.22 9.21 9.22 23.17t-9.22 23.17q-9.22 9.22-23.18 9.22Z" />
    </svg>
  )
}
